var _defs, _rect, _path, _path2, _b, _text, _path3, _path4, _br, _text2, _path5, _path6, _b2, _text3, _path7, _path8, _path9, _path10, _rect2, _rect3, _path11, _path12, _path13, _text4, _b3, _text5, _text6, _b4, _text7, _text8, _path14, _path15, _path16, _text9, _b5, _text10, _b6, _text11, _text12, _text13, _text14, _b7, _text15, _b8, _text16, _rect4, _path17, _path18, _path19, _b9, _text17, _text18, _text19, _text20, _path20, _path21, _path22, _text21, _b10, _text22, _path23, _path24, _path25, _b11, _text23, _b12, _text24, _text25, _path26, _path27, _path28, _text26, _text27, _b13, _text28, _text29, _b14, _text30, _text31, _text32, _text33, _text34, _text35, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _text36, _text37, _b15, _text38, _b16, _text39, _path43, _b17, _text40, _path44, _path45, _rect5, _text41, _path46, _b18, _text42, _rect6, _path47, _path48, _b19, _text43, _path49, _path50, _path51, _b20, _text44, _rect7, _path52, _path53, _b21, _text45, _path54, _path55, _path56, _b22, _text46, _text47, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _text48, _path65, _path66, _b23, _text49, _switch;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDataPipelinedrawio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "2203px",
    height: "591px",
    viewBox: "-0.5 -0.5 2203 591",
    content: "<mxfile host=\"app.diagrams.net\" modified=\"2023-05-05T06:48:35.629Z\" agent=\"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/112.0.0.0 Safari/537.36\" etag=\"DnNo0daq6tvnDq7EoRu2\" version=\"21.2.9\" type=\"google\"><diagram name=\"Page-1\" id=\"8lPKmc9DrucsQAhg_g0c\">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</diagram></mxfile>",
    style: {
      backgroundColor: "rgb(255, 255, 255)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "@import url(https://fonts.googleapis.com/css?family=Architects+Daughter);&#xa;"))), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 261,
    y: 93,
    width: 490,
    height: 430,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 560.07 160.82 L 560.07 251.25 L 468.5 251.25 L 468.5 145.75 L 546.98 145.75 Z",
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 546.98 145.75 C 548.05 149.28 546.3 152.91 542.31 155.44 L 560.07 161.14",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 91,
      height: 1,
      paddingTop: 199,
      marginLeft: 470
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 17
    }
  }, _b || (_b = /*#__PURE__*/React.createElement("b", null, "etf Dataframe"))))))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 515,
    y: 202,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "etf Dataframe")))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 557.59 373.93 L 557.59 463.5 L 468.5 463.5 L 468.5 359 L 544.86 359 Z",
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 544.86 359 C 545.9 362.49 544.2 366.09 540.32 368.6 L 557.59 374.25",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 411,
      marginLeft: 470
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("b", {
    style: {
      fontSize: 16
    }
  }, "stocks", _br || (_br = /*#__PURE__*/React.createElement("br", null)), "Dataframe"))))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 514,
    y: 415,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "stocks...")))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 739.79 233.86 L 739.79 359 L 621 359 L 621 213 L 722.82 213 Z",
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 722.82 213 C 724.2 217.88 721.93 222.91 716.76 226.41 L 739.79 234.3",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 286,
      marginLeft: 622
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 16
    }
  }, _b2 || (_b2 = /*#__PURE__*/React.createElement("b", null, "preprocessed", /*#__PURE__*/React.createElement("br", null), "Dataframe"))))))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 681,
    y: 290,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "preprocessed...")))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 561 198.5 Q 581 199 571 256 Q 561 313 614.96 295.01",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 619.94 293.35 L 614.41 298.89 L 614.96 295.01 L 612.19 292.25 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 556.61 418.77 Q 581 423 571 363 Q 561 303 613.51 294.6",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 618.7 293.77 L 612.34 298.33 L 613.51 294.6 L 611.23 291.42 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 892,
    y: 50,
    width: 1010,
    height: 540,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "none"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1132,
    y: 104.31,
    width: 430,
    height: 210,
    fill: "#dae8fc",
    stroke: "#6c8ebf",
    pointerEvents: "none"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 1152 182.41 L 1152 152.41 L 1312 152.41 L 1312 182.41",
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 1152 182.41 L 1152 266.21 L 1312 266.21 L 1312 182.41",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 1152 182.41 L 1312 182.41",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 158,
      height: 1,
      paddingTop: 167,
      marginLeft: 1153
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 14
    }
  }, "Preprocessed Dataframe &lt;subset&gt;")))))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 1232,
    y: 171,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Preprocessed Dataframe &lt;su...")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 150,
      height: 1,
      paddingTop: 196,
      marginLeft: 1158
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left",
      maxHeight: 24,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 14
    }
  }, _b3 || (_b3 = /*#__PURE__*/React.createElement("b", null, "Date: Date"))))))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 1158,
    y: 200,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "Date: Date")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 150,
      height: 1,
      paddingTop: 224,
      marginLeft: 1158
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left",
      maxHeight: 24,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 14
    }
  }, "Symbol: String")))))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 1158,
    y: 228,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "Symbol: String")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 150,
      height: 1,
      paddingTop: 252,
      marginLeft: 1158
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left",
      maxHeight: 24,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 14
    }
  }, _b4 || (_b4 = /*#__PURE__*/React.createElement("b", null, "Adj Close: Float"))))))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 1158,
    y: 256,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "Adj Close: Float")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 130,
      height: 1,
      paddingTop: 259,
      marginLeft: 918
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left",
      maxHeight: 24,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 14
    }
  }, "Symbol: String")))))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 918,
    y: 262,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "Symbol: String")))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 912 240.59 L 912 217.59 L 1092 217.59 L 1092 240.59",
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M 912 240.59 L 912 468.97 L 1092 468.97 L 1092 240.59",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M 912 240.59 L 1092 240.59",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 178,
      height: 1,
      paddingTop: 229,
      marginLeft: 913
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 15
    }
  }, "Preprocessed Dataframe"))))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 1002,
    y: 233,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "Preprocessed Dataframe")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 170,
      height: 1,
      paddingTop: 286,
      marginLeft: 918
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left",
      maxHeight: 24,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 14
    }
  }, _b5 || (_b5 = /*#__PURE__*/React.createElement("b", null, "Security Name: String"))))))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 918,
    y: 290,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "Security Name: String")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 130,
      height: 1,
      paddingTop: 314,
      marginLeft: 918
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left",
      maxHeight: 24,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 14
    }
  }, _b6 || (_b6 = /*#__PURE__*/React.createElement("b", null, "Data: Date"))))))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 918,
    y: 318,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "Data: Date")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 130,
      height: 1,
      paddingTop: 342,
      marginLeft: 918
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left",
      maxHeight: 24,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 14
    }
  }, "Open: Float")))))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 918,
    y: 346,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "Open: Float")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 130,
      height: 1,
      paddingTop: 370,
      marginLeft: 918
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left",
      maxHeight: 24,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 14
    }
  }, "High: Float")))))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 918,
    y: 374,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "High: Float")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 130,
      height: 1,
      paddingTop: 398,
      marginLeft: 918
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left",
      maxHeight: 24,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 14
    }
  }, "Close: Float")))))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 918,
    y: 402,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "Close: Float")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 130,
      height: 1,
      paddingTop: 426,
      marginLeft: 918
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left",
      maxHeight: 24,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 14
    }
  }, _b7 || (_b7 = /*#__PURE__*/React.createElement("b", null, "Adj Close: Float"))))))), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 918,
    y: 430,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "Adj Close: Float")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 130,
      height: 1,
      paddingTop: 454,
      marginLeft: 918
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left",
      maxHeight: 24,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 14
    }
  }, _b8 || (_b8 = /*#__PURE__*/React.createElement("b", null, "Volume: Float"))))))), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 918,
    y: 458,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "Volume: Float")))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1132,
    y: 360,
    width: 430,
    height: 210,
    fill: "#dae8fc",
    stroke: "#6c8ebf",
    pointerEvents: "none"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M 1152 424.02 L 1152 394.02 L 1312 394.02 L 1312 424.02",
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M 1152 424.02 L 1152 507.81 L 1312 507.81 L 1312 424.02",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M 1152 424.02 L 1312 424.02",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 158,
      height: 1,
      paddingTop: 409,
      marginLeft: 1153
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 14
    }
  }, _b9 || (_b9 = /*#__PURE__*/React.createElement("b", null, "Preprocessed Dataframe "))), /*#__PURE__*/React.createElement("b", {
    style: {
      borderColor: "var(--border-color)"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      borderColor: "var(--border-color)",
      fontSize: 14
    }
  }, "&lt;subset&gt;")))))), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 1232,
    y: 413,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Preprocessed Dataframe &lt;su...")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 150,
      height: 1,
      paddingTop: 438,
      marginLeft: 1158
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left",
      maxHeight: 24,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 14
    }
  }, "Date: Date")))))), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 1158,
    y: 442,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "Date: Date")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 150,
      height: 1,
      paddingTop: 466,
      marginLeft: 1158
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left",
      maxHeight: 24,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 14
    }
  }, "Symbol: String")))))), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 1158,
    y: 470,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "Symbol: String")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 150,
      height: 1,
      paddingTop: 494,
      marginLeft: 1158
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left",
      maxHeight: 24,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 14
    }
  }, "Volume: Float")))))), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 1158,
    y: 497,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "Volume: Float")))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M 1352 205.69 L 1352 175.69 L 1532 175.69 L 1532 205.69",
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M 1352 205.69 L 1352 242.93 L 1532 242.93 L 1532 205.69",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M 1352 205.69 L 1532 205.69",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 178,
      height: 1,
      paddingTop: 191,
      marginLeft: 1353
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 14
    }
  }, "adj_close_rolling_med series")))))), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 1442,
    y: 194,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "adj_close_rolling_med series")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 170,
      height: 1,
      paddingTop: 224,
      marginLeft: 1358
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left",
      maxHeight: 33,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 14
    }
  }, _b10 || (_b10 = /*#__PURE__*/React.createElement("b", null, "adj_close_rolling_med: Float"))))))), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 1358,
    y: 228,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "adj_close_rolling_med: Float")))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M 1352 451.95 L 1352 421.95 L 1532 421.95 L 1532 451.95",
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M 1352 451.95 L 1352 479.88 L 1532 479.88 L 1532 451.95",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M 1352 451.95 L 1532 451.95",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 178,
      height: 1,
      paddingTop: 437,
      marginLeft: 1353
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 14
    }
  }, _b11 || (_b11 = /*#__PURE__*/React.createElement("b", null, "vol_moving_avg series"))))))), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 1442,
    y: 441,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "vol_moving_avg series")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 170,
      height: 1,
      paddingTop: 466,
      marginLeft: 1358
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left",
      maxHeight: 24,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 14
    }
  }, _b12 || (_b12 = /*#__PURE__*/React.createElement("b", null, "vol_moving_avg: Float"))))))), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 1358,
    y: 470,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "vol_moving_avg: Float")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 130,
      height: 1,
      paddingTop: 231,
      marginLeft: 1668
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left",
      maxHeight: 24,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 14
    }
  }, "Symbol: String")))))), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 1668,
    y: 234,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "Symbol: String")))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M 1662 212.66 L 1662 189.66 L 1862 189.66 L 1862 212.66",
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M 1662 212.66 L 1662 506.21 L 1862 506.21 L 1862 212.66",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M 1662 212.66 L 1862 212.66",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 198,
      height: 1,
      paddingTop: 201,
      marginLeft: 1663
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Featured Engineered Dataframe")))), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 1762,
    y: 205,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "Featured Engineered Dataframe")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 190,
      height: 1,
      paddingTop: 456,
      marginLeft: 1668
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left",
      maxHeight: 24,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("b", {
    style: {
      fontSize: 13
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 13
    }
  }, "adj_close_rolling_med: "), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 13
    }
  }, "Float")))))), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 1668,
    y: 460,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "adj_close_rolling_med: Float")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 180,
      height: 1,
      paddingTop: 484,
      marginLeft: 1668
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left",
      maxHeight: 24,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 13
    }
  }, _b13 || (_b13 = /*#__PURE__*/React.createElement("b", null, "vol_moving_avg: Float"))))))), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    x: 1668,
    y: 487,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "vol_moving_avg: Float")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 170,
      height: 1,
      paddingTop: 259,
      marginLeft: 1668
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left",
      maxHeight: 24,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 14
    }
  }, "Security Name: String")))))), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    x: 1668,
    y: 262,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "Security Name: String")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 130,
      height: 1,
      paddingTop: 286,
      marginLeft: 1668
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left",
      maxHeight: 24,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 14
    }
  }, _b14 || (_b14 = /*#__PURE__*/React.createElement("b", null, "Data: Date"))))))), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    x: 1668,
    y: 290,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "Data: Date")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 130,
      height: 1,
      paddingTop: 314,
      marginLeft: 1668
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left",
      maxHeight: 24,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 14
    }
  }, "Open: Float")))))), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    x: 1668,
    y: 318,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "Open: Float")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 130,
      height: 1,
      paddingTop: 342,
      marginLeft: 1668
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left",
      maxHeight: 24,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 14
    }
  }, "High: Float")))))), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    x: 1668,
    y: 346,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "High: Float")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 130,
      height: 1,
      paddingTop: 370,
      marginLeft: 1668
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left",
      maxHeight: 24,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 14
    }
  }, "Close: Float")))))), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    x: 1668,
    y: 374,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "Close: Float")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 130,
      height: 1,
      paddingTop: 398,
      marginLeft: 1668
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left",
      maxHeight: 24,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 14
    }
  }, "Adj Close: Float")))))), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    x: 1668,
    y: 402,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "Adj Close: Float")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 130,
      height: 1,
      paddingTop: 426,
      marginLeft: 1668
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left",
      maxHeight: 24,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 14
    }
  }, "Volume: Float")))))), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    x: 1668,
    y: 430,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "Volume: Float")))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M 1092 343.28 Q 1122 343.28 1122 285.09 Q 1122 226.9 1145.66 224.86",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M 1150.89 224.41 L 1144.21 228.49 L 1145.66 224.86 L 1143.61 221.52 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M 1092 343.28 Q 1122 338.62 1117 403.79 Q 1112 468.97 1145.65 466.4",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M 1150.89 466 L 1144.17 470.02 L 1145.65 466.4 L 1143.64 463.04 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M 1312 224.31 L 1345.63 224.31",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M 1350.88 224.31 L 1343.88 227.81 L 1345.63 224.31 L 1343.88 220.81 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M 1312 465.91 L 1345.63 465.91",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M 1350.88 465.91 L 1343.88 469.41 L 1345.63 465.91 L 1343.88 462.41 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M 1092 343.28 L 1655.63 342.36",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M 1660.88 342.35 L 1653.89 345.86 L 1655.63 342.36 L 1653.88 338.86 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M 1532 224.31 Q 1562 226.9 1567 250.17 Q 1572 273.45 1577 310.69 Q 1582 347.93 1655.65 342.79",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M 1660.88 342.42 L 1654.15 346.4 L 1655.65 342.79 L 1653.66 339.42 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M 1532 465.91 Q 1582 468.97 1572 403.79 Q 1562 338.62 1655.64 342.11",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M 1660.88 342.3 L 1653.76 345.54 L 1655.64 342.11 L 1654.02 338.55 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 108,
      height: 1,
      paddingTop: 545,
      marginLeft: 1283
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("b", {
    style: {
      borderColor: "var(--border-color)"
    }
  }, "ThreadPool"))))), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    x: 1337,
    y: 549,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "ThreadPool")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 108,
      height: 1,
      paddingTop: 295,
      marginLeft: 1283
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("b", {
    style: {
      borderColor: "var(--border-color)"
    }
  }, "ThreadPool"))))), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    x: 1337,
    y: 299,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "ThreadPool")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 188,
      height: 1,
      paddingTop: 68,
      marginLeft: 262
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 23
    }
  }, _b15 || (_b15 = /*#__PURE__*/React.createElement("b", null, "Data Ingestion"))))))), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    x: 356,
    y: 72,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Data Ingestion")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 188,
      height: 1,
      paddingTop: 15,
      marginLeft: 883
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 23
    }
  }, _b16 || (_b16 = /*#__PURE__*/React.createElement("b", null, "Data Transform"))))))), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
    x: 977,
    y: 19,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Data Transform")))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M 20.64 436.34 L 20.64 378.67 L 109.36 378.67 L 109.36 436.34 Z M 48.56 356.49 L 56.78 364.72 C 57.2 365.14 57.76 365.37 58.35 365.37 L 109.36 365.37 L 109.36 374.24 L 20.64 374.24 L 20.64 356.49 Z M 113.79 363.15 C 113.79 361.93 112.8 360.93 111.58 360.93 L 59.27 360.93 L 51.04 352.71 C 50.63 352.29 50.06 352.06 49.47 352.06 L 18.42 352.06 C 17.84 352.06 17.27 352.29 16.86 352.71 C 16.44 353.12 16.21 353.69 16.21 354.28 L 16.21 376.46 L 16.21 438.56 C 16.21 439.14 16.44 439.71 16.86 440.12 C 17.27 440.54 17.84 440.77 18.42 440.77 L 111.58 440.77 C 112.16 440.77 112.73 440.54 113.14 440.12 C 113.56 439.71 113.79 439.14 113.79 438.56 L 113.79 376.46 L 113.79 376.43 Z",
    fill: "#232f3d",
    stroke: "none",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 128,
      height: 1,
      paddingTop: 408,
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 19
    }
  }, _b17 || (_b17 = /*#__PURE__*/React.createElement("b", null, "Stocks"))))))), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
    x: 65,
    y: 412,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Stocks")))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M 1862 347.93 L 2015.63 347.93",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M 2020.88 347.93 L 2013.88 351.43 L 2015.63 347.93 L 2013.88 344.43 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 2022,
    y: 242.93,
    width: 169,
    height: 210,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 167,
      height: 1,
      paddingTop: 348,
      marginLeft: 2023
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 17
    }
  }, "LightGBM\xA0")))))), _text41 || (_text41 = /*#__PURE__*/React.createElement("text", {
    x: 2107,
    y: 352,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "LightGBM\xA0")))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M 21.64 232.76 L 21.64 175.09 L 110.36 175.09 L 110.36 232.76 Z M 49.56 152.91 L 57.78 161.14 C 58.2 161.56 58.76 161.79 59.35 161.79 L 110.36 161.79 L 110.36 170.66 L 21.64 170.66 L 21.64 152.91 Z M 114.79 159.57 C 114.79 158.35 113.8 157.35 112.58 157.35 L 60.27 157.35 L 52.04 149.13 C 51.63 148.71 51.06 148.48 50.47 148.48 L 19.42 148.48 C 18.84 148.48 18.27 148.71 17.86 149.13 C 17.44 149.54 17.21 150.11 17.21 150.7 L 17.21 172.88 L 17.21 234.98 C 17.21 235.56 17.44 236.13 17.86 236.54 C 18.27 236.96 18.84 237.19 19.42 237.19 L 112.58 237.19 C 113.16 237.19 113.73 236.96 114.14 236.54 C 114.56 236.13 114.79 235.56 114.79 234.98 L 114.79 172.88 L 114.79 172.85 Z",
    fill: "#232f3d",
    stroke: "none",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 128,
      height: 1,
      paddingTop: 202,
      marginLeft: 2
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 19
    }
  }, _b18 || (_b18 = /*#__PURE__*/React.createElement("b", null, "ETFs"))))))), _text42 || (_text42 = /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 205,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "ETFs")))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 331.25,
    width: 120,
    height: 171.75,
    fill: "#dae8fc",
    stroke: "#6c8ebf",
    pointerEvents: "none"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M 390.39 349.74 L 390.39 390.21 L 331 390.21 L 331 343 L 381.91 343 Z",
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M 381.91 343 C 382.6 344.58 381.46 346.2 378.88 347.34 L 390.39 349.89",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 58,
      height: 1,
      paddingTop: 367,
      marginLeft: 332
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 17
    }
  }, _b19 || (_b19 = /*#__PURE__*/React.createElement("b", null, "csv"))))))), _text43 || (_text43 = /*#__PURE__*/React.createElement("text", {
    x: 361,
    y: 370,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "csv")))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M 360.51 418.53 L 360.51 394.93",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "2 6",
    pointerEvents: "none"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M 390.39 433.54 L 390.39 474 L 331 474 L 331 426.79 L 381.91 426.79 Z",
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M 381.91 426.79 C 382.6 428.37 381.46 430 378.88 431.13 L 390.39 433.68",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 58,
      height: 1,
      paddingTop: 450,
      marginLeft: 332
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 17
    }
  }, _b20 || (_b20 = /*#__PURE__*/React.createElement("b", null, "csv"))))))), _text44 || (_text44 = /*#__PURE__*/React.createElement("text", {
    x: 361,
    y: 454,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "csv")))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 123,
    width: 120,
    height: 171.75,
    fill: "#dae8fc",
    stroke: "#6c8ebf",
    pointerEvents: "none"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M 390.39 139.74 L 390.39 180.21 L 331 180.21 L 331 133 L 381.91 133 Z",
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M 381.91 133 C 382.6 134.58 381.46 136.2 378.88 137.34 L 390.39 139.89",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 58,
      height: 1,
      paddingTop: 157,
      marginLeft: 332
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 17
    }
  }, _b21 || (_b21 = /*#__PURE__*/React.createElement("b", null, "csv"))))))), _text45 || (_text45 = /*#__PURE__*/React.createElement("text", {
    x: 361,
    y: 160,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "csv")))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M 360.51 208.53 L 360.51 184.93",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "2 6",
    pointerEvents: "none"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M 390.39 223.54 L 390.39 264 L 331 264 L 331 216.79 L 381.91 216.79 Z",
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M 381.91 216.79 C 382.6 218.37 381.46 220 378.88 221.13 L 390.39 223.68",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 58,
      height: 1,
      paddingTop: 240,
      marginLeft: 332
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 17
    }
  }, _b22 || (_b22 = /*#__PURE__*/React.createElement("b", null, "csv"))))))), _text46 || (_text46 = /*#__PURE__*/React.createElement("text", {
    x: 361,
    y: 244,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "csv")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 108,
      height: 1,
      paddingTop: 287,
      marginLeft: 307
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("b", {
    style: {
      borderColor: "var(--border-color)"
    }
  }, "ThreadPool"))))), _text47 || (_text47 = /*#__PURE__*/React.createElement("text", {
    x: 361,
    y: 291,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "ThreadPool")))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M 130 408.1 L 324.63 408.97",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M 329.88 408.99 L 322.87 412.46 L 324.63 408.97 L 322.9 405.46 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M 406 412.5 L 449.63 412.5",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M 454.88 412.5 L 447.88 416 L 449.63 412.5 L 447.88 409 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M 131 201.02 L 324.63 199.06",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M 329.88 199.01 L 322.92 202.58 L 324.63 199.06 L 322.85 195.58 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M 401 203 L 454.63 203",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M 459.88 203 L 452.88 206.5 L 454.63 203 L 452.88 199.5 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 108,
      height: 1,
      paddingTop: 496,
      marginLeft: 307
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("b", {
    style: {
      borderColor: "var(--border-color)"
    }
  }, "ThreadPool"))))), _text48 || (_text48 = /*#__PURE__*/React.createElement("text", {
    x: 361,
    y: 500,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "ThreadPool")))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M 741 286 L 905.63 286.46",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M 910.88 286.48 L 903.87 289.96 L 905.63 286.46 L 903.89 282.96 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 188,
      height: 1,
      paddingTop: 218,
      marginLeft: 2013
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "none",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 23
    }
  }, _b23 || (_b23 = /*#__PURE__*/React.createElement("b", null, "Model Training"))))))), _text49 || (_text49 = /*#__PURE__*/React.createElement("text", {
    x: 2107,
    y: 222,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Model Training"))))), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }), /*#__PURE__*/React.createElement("a", {
    transform: "translate(0,-5)",
    xlinkHref: "https://www.drawio.com/doc/faq/svg-export-text-problems",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fontSize: "10px",
    x: "50%",
    y: "100%"
  }, "Text is not SVG - cannot display")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataPipelinedrawio);
export default __webpack_public_path__ + "static/media/data_pipeline.drawio.2b0af29b9c47d96af623819e1d5c0454.svg";
export { ForwardRef as ReactComponent };